import $ from 'jquery';
import 'jquery-migrate';
$.migrateMute = true;
// Initialize jQuery globally immediately when this module is loaded
// This fix is to try to fix HealthCheck Issue EL-5.
window.jQuery = $;
window.$ = $;
export default function initJqueryGlobal() {
    window.jQuery = $;
    window.$ = $;
}
